// extracted by mini-css-extract-plugin
export var statItem = "_ei-1";
export var statsRow = "_ei-0";